/**
 * Functional wrapper for switching between app configs.
 * It keeps all props switching isolated to single function
 */
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';


export default compose(
  connect(state => ({
    config: state.config,
    experiment: state.experimentV2,
  })),
  setPropTypes({
    config: PropTypes.shape({
      appName: PropTypes.string.isRequired,
    }).isRequired,
    experiment: PropTypes.object.isRequired,
  }),
);



// WEBPACK FOOTER //
// ./src/modules/home/browser/withBusinessListFeatureFlaggedPageConfig.js